import { BsSave } from "react-icons/bs";
import { useEffect, useState } from "react";
import { Button, Card, Form, InputGroup } from "react-bootstrap";
import { userServices } from "../../../APIServices/UserData/userServices";
import Swal from "sweetalert2";
import { authServices } from "../../../APIServices/UserData/authServices";
import { BiReset } from "react-icons/bi";

const SecuritySettings = ({ auth, setUpdator, currentUserData }) => {
  const [sessionExpiry, setSessionExpiry] = useState("1h");
  const [tokenExpiry, setTokenExpiry] = useState("1h");
  const [loginLimits, setLoginLimits] = useState("3");
  const [blockingTime, setBlockingTime] = useState("60");
  const [loader, setLoader] = useState("");

  const updateSecuritySettings = async (type) => {
    Swal.fire({
      title: "Confirm Update",
      text: (type === "resetTokenExpiry") ? "Do you want to reset session expiry Auto logout settings?"
        : (type === "resetSessionExpiry") ? "Do you want to reset no activity Auto logout settings?"
          : (type === "resetLoginLimits") ? "Do you want to reset Login limit settings?"
            : (type === "tokenExpiry") ? "Updating the auto logout (session expired) will log you out immediately after the change. Do you want to continue?"
              : (type === "sessionExpiry") ? "Do you want to update the auto logout (if no activity) settings?"
                : "Do you want to update the security settings?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: (type === "resetTokenExpiry" || type === "resetSessionExpiry" || type === "resetLoginLimits")
        ? "Yes, reset it!"
        : type === "tokenExpiry"
          ? "Yes, Update & Logout it!"
          : "Yes, Update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(type);
        let userData = {};
        if (type === "sessionExpiry") {
          userData.sessionExpiry = sessionExpiry;
        }
        if (type === "resetSessionExpiry") {
          userData.sessionExpiry = "1h";
        }
        if (type === "tokenExpiry") {
          userData.tokenExpiry = tokenExpiry;
        }
        if (type === "resetTokenExpiry") {
          userData.tokenExpiry = "1h";
        }
        if (type === "loginLimits") {
          userData.limitLogin = loginLimits;
          userData.blockingTime = blockingTime;
        }
        if (type === "resetLoginLimits") {
          userData.limitLogin = "3";
          userData.blockingTime = "60";
        }
        const data = await userServices.updateProfile(auth, userData);
        if (data?.statusCode === 200) {
          if (type === "tokenExpiry") {
            authServices.logout(auth);
          } else {
            setUpdator(type);
          }
        }
        setLoader("");
      }
    });
  };

  useEffect(() => {
    if (currentUserData) {
      setSessionExpiry(currentUserData?.sessionExpiry || "1h");
      setTokenExpiry(currentUserData?.tokenExpiry || "1h");
      setLoginLimits(currentUserData?.limitLogin || "3");
      setBlockingTime(currentUserData?.blockingTime || "60");
    }
  }, [currentUserData]);


  return (
    <>
      <div className="w-50 m-auto pb-1 pt-3 hstack justify-content-between">
        <h5 className="fw-bold mb-1">Security Settings</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        <div className="w-50 m-auto py-3">
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <div className="hstack justify-content-between mb-2">
                <Form.Label className="m-0 fw-bold" style={{ fontSize: 13 }}>Login Limits</Form.Label>
                <div className="hstack gap-2">
                  {!(currentUserData?.limitLogin === "3" && currentUserData?.blockingTime === "60") &&
                    <Button
                      disabled={loader}
                      variant="outline-danger"
                      style={{ fontSize: 13 }}
                      onClick={() => updateSecuritySettings("resetLoginLimits")}
                      title="Reset Login Limits Settings"
                      className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                    >
                      <BiReset /> Reset
                    </Button>
                  }
                  <Button
                    disabled={loader}
                    variant="outline-primary"
                    style={{ fontSize: 13 }}
                    onClick={() => updateSecuritySettings("loginLimits")}
                    title="Save Login Limits Settings"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <BsSave /> Save
                  </Button>
                </div>
              </div>
              <Form.Group className="mb-2">
                <Form.Select className="interactive-input rounded-1 mb-1"
                  value={loginLimits}
                  disabled={loader}
                  onChange={(e) => setLoginLimits(e.target.value)}
                  style={{ fontSize: 12, padding: "6px 15px" }}>
                  <option value={`2`}>2 Times</option>
                  <option value={`3`}>3 Times</option>
                  <option value={`5`}>5 Times</option>
                  <option value={`7`}>7 Times</option>
                </Form.Select>
                <p className="text-muted mb-1" style={{ fontSize: 11, lineHeight: 1.3 }}>You can log in up to {loginLimits} times before your session automatically expires.</p>
              </Form.Group>
              <Form.Group className="mb-1">
                <Form.Label className="mb-1 fw-bold" style={{ fontSize: 13 }}>Blocking Time</Form.Label>
                <InputGroup>
                  <Form.Control className="interactive-input"
                    placeholder="Enter"
                    value={blockingTime}
                    onChange={(e) => setBlockingTime(e.target.value)}
                    style={{ fontSize: 12, padding: "6px 15px" }} type="number"
                  />
                  <InputGroup.Text style={{ fontSize: 13 }}>Minutes</InputGroup.Text>
                </InputGroup>
              </Form.Group>
              <p className="text-muted mb-1" style={{ fontSize: 11, lineHeight: 1.3 }}>
                You can log in again after {blockingTime} minutes if your IP address is blocked due to entering an incorrect password {loginLimits} times.
              </p>
            </Card.Body>
          </Card>
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <div className="hstack justify-content-between mb-2">
                <Form.Label className="m-0 fw-bold" style={{ fontSize: 13 }}>Auto logout when no activity</Form.Label>
                <div className="hstack gap-2">
                  {!(currentUserData?.sessionExpiry === "1h") &&
                    <Button
                      disabled={loader}
                      variant="outline-danger"
                      style={{ fontSize: 13 }}
                      onClick={() => updateSecuritySettings("resetSessionExpiry")}
                      title="Reset Auto logout when no activity Settings"
                      className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                    >
                      <BiReset /> Reset
                    </Button>
                  }
                  <Button
                    disabled={loader}
                    variant="outline-primary"
                    style={{ fontSize: 13 }}
                    onClick={() => updateSecuritySettings("sessionExpiry")}
                    title="Save Auto logout when no activity Settings"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <BsSave /> Save
                  </Button>
                </div>
              </div>
              <Form.Group className="mb-2">
                <Form.Select className="interactive-input rounded-1 mb-1"
                  value={sessionExpiry}
                  disabled={loader}
                  onChange={(e) => setSessionExpiry(e.target.value)}
                  style={{ fontSize: 12, padding: "6px 15px" }}>
                  <option value={`1m`}>1 Minutes</option>
                  <option value={`5m`}>5 Minutes</option>
                  <option value={`10m`}>10 Minutes</option>
                  <option value={`15m`}>15 Minutes</option>
                  <option value={`30m`}>30 Minutes</option>
                  <option value={`1h`}>1 Hour</option>
                  <option value={`2h`}>2 Hours</option>
                  <option value={`3h`}>3 Hours</option>
                  <option value={`5h`}>5 Hours</option>
                  <option value={`8h`}>8 Hours</option>
                  <option value={`12h`}>12 Hours</option>
                  <option value={`1d`}>1 Day</option>
                </Form.Select>
                <p className="text-muted mb-1" style={{ fontSize: 11, lineHeight: 1.3 }}>If you don’t use the app for a selected time, you’ll be logged out automatically to keep your account secure.</p>
              </Form.Group>
            </Card.Body>
          </Card>
          <Card className="border rounded-1 mb-3">
            <Card.Body>
              <div className="hstack justify-content-between mb-2">
                <Form.Label className="m-0 fw-bold" style={{ fontSize: 13 }}>Auto logout when session expired</Form.Label>
                <div className="hstack gap-2">
                  {!(currentUserData?.tokenExpiry === "1h") &&
                    <Button
                      disabled={loader}
                      variant="outline-danger"
                      style={{ fontSize: 13 }}
                      onClick={() => updateSecuritySettings("resetTokenExpiry")}
                      title="Reset Auto Auto logout when session expired Settings"
                      className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                    >
                      <BiReset /> Reset
                    </Button>
                  }
                  <Button
                    disabled={loader}
                    variant="outline-primary"
                    style={{ fontSize: 13 }}
                    onClick={() => updateSecuritySettings("tokenExpiry")}
                    title="Save Auto logout when session expired Settings"
                    className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
                  >
                    <BsSave /> Save
                  </Button>
                </div>
              </div>
              <Form.Group className="mb-2">
                <Form.Select className="interactive-input rounded-1 mb-1"
                  value={tokenExpiry}
                  disabled={loader}
                  onChange={(e) => setTokenExpiry(e.target.value)}
                  style={{ fontSize: 12, padding: "6px 15px" }}>
                  <option value={`2m`}>2 Minutes</option>
                  <option value={`1h`}>1 Hour</option>
                  <option value={`2h`}>2 Hours</option>
                  <option value={`3h`}>3 Hours</option>
                  <option value={`5h`}>5 Hours</option>
                  <option value={`8h`}>8 Hours</option>
                  <option value={`12h`}>12 Hours</option>
                  <option value={`1d`}>1 Day</option>
                </Form.Select>
                <p className="text-muted mb-1" style={{ fontSize: 11, lineHeight: 1.3 }}>You’ll be logged out automatically when your login session expires, even if you’re still using the app.</p>
              </Form.Group>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default SecuritySettings;
